import { useEffect } from 'react';
import { useRecipeFilterContext } from '@/context/recipeFilter';

// import api
import apiBrowseByFacet from '@/api/get/recipe/browseByFacet';

export default initialBrowseBy => {
  const [
    { browseBy, browseByFacet, query },
    { setBrowseBy, setBrowseByFacet },
  ] = useRecipeFilterContext();

  useEffect(() => {
    if (initialBrowseBy) {
      setBrowseBy(initialBrowseBy);
    }
  }, []);

  useEffect(() => {
    if (browseBy && !browseByFacet) {
      apiBrowseByFacet({
        facetCode: browseBy,
        q: query.value,
        successCB: setBrowseByFacet,
      });
    }
  }, [browseBy, query.value]);
};
